/**
 * Input parameters for all paginated graphql endpoints
 */
export const PAGINATION_INPUT_PARAMS = {
  first: {
    type: 'int',
    isOptional: true,
  },
  offset: {
    type: 'int',
    isOptional: true,
    default: 0,
  },
  last: {
    type: 'int',
    isOptional: true,
  },
} as const;

/**
 * Input parameters for paginated graphql endpoints that use cursor pagination
 */
export const CURSOR_PAGINATION_INPUT_PARAMS = {
  first: {
    type: 'int',
    isOptional: true,
  },
  last: {
    type: 'int',
    isOptional: true,
  },
  before: {
    type: 'string',
    isOptional: true,
  },
  after: {
    type: 'string',
    isOptional: true,
  },
} as const;

export const CURSOR_AND_OFFSET_PAGINATION_INPUT_PARAMS = {
  ...CURSOR_PAGINATION_INPUT_PARAMS,
  offset: {
    ...PAGINATION_INPUT_PARAMS.offset,
    deprecated: 'This parameter is deprecated. Use before/after instead.',
  },
} as const;

/**
 * Input params for setting database reading and writing preferences
 */
export const DATABASE_PREFERENCE_PARAMS = {
  useMaster: {
    comment: 'Whether to read from the master DB',
    type: 'boolean',
    isOptional: true,
  },
  isExportCsv: {
    comment: `Whether the query is being triggered as part of an export to CSV request.
      This optimizes the query by not grouping and ordering by unnecessary fields.`,
    type: 'boolean',
    isOptional: true,
  },
} as const;
